// sol/SolApp.js
import React from "react";


import Design from "./Design";

export default function UsdtApp() {
  return (
   
      <div>
       
        <Design/>
       
      </div>
    
  );
}
